import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  makeStyles,
  tokens,
  Text,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  choices: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
  choiceBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
  },
  helpText: {
    color: tokens.colorNeutralForeground3,
  },
});

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onChoose: (mode: 'original' | 'amendment') => void;
  isPending?: boolean;
}

export default function ReopenChoiceDialog({ open, onOpenChange, onChoose, isPending }: Props) {
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onOpenChange={(_e, d) => {
        if (!isPending) onOpenChange(d.open);
      }}
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{t('taskDetailPage.reopen.title')}</DialogTitle>
          <DialogContent>
            <div className={styles.choices}>
              <div className={styles.choiceBlock}>
                <Button
                  appearance="secondary"
                  disabled={isPending}
                  onClick={() => onChoose('original')}
                >
                  {t('taskDetailPage.reopen.original.label')}
                </Button>
                <Text className={styles.helpText} size={200}>
                  {t('taskDetailPage.reopen.original.help')}
                </Text>
              </div>
              <div className={styles.choiceBlock}>
                <Button
                  appearance="secondary"
                  disabled={isPending}
                  onClick={() => onChoose('amendment')}
                >
                  {t('taskDetailPage.reopen.amendment.label')}
                </Button>
                <Text className={styles.helpText} size={200}>
                  {t('taskDetailPage.reopen.amendment.help')}
                </Text>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              appearance="secondary"
              disabled={isPending}
              onClick={() => onOpenChange(false)}
            >
              {t('taskDetailPage.reopen.cancel')}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
